module.exports = __webpack_public_path__ + "static/media/team22.55c6d84b.png";